import { ref } from 'vue';

// Capturé au chargement du module (importé tôt dans main.ts) : l'event ne se
// déclenche qu'une fois et doit être écouté avant que le navigateur ne l'émette.
let deferredPrompt: any = null;

export const canInstall = ref(false);

window.addEventListener('beforeinstallprompt', (e: Event) => {
  e.preventDefault();
  deferredPrompt = e;
  canInstall.value = true;
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  canInstall.value = false;
});

// true si un prompt natif est disponible (Chrome/Edge Android + desktop). Sur iOS Safari
// et sur les navigateurs qui n'exposent pas beforeinstallprompt, retombe toujours à false
// — l'appelant doit alors afficher des instructions manuelles.
export async function promptInstall(): Promise<boolean> {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  canInstall.value = false;
  return outcome === 'accepted';
}

export function usePwaInstall() {
  return { canInstall, promptInstall };
}
